<script lang="ts">
  import { assets } from '$app/paths';

  let { legendBg, legendPattern } = $props();
</script>

<div class="table-legend" aria-label="Table legend">
  <ul class="table-legend__list">
    <!-- <li class="table-legend__item">
      <span class="table-legend__key table-legend__key--fill" aria-hidden="true"
      ></span>
      <span>{legendBg}</span>
    </li> -->
    <li
      class="table-legend__item"
      style={`--icon: url( ${assets}/images/us-base.png)`}
    >
      <span
        class="table-legend__key table-legend__key--pattern"
        aria-hidden="true"
      ></span>
      <span>{legendPattern}</span>
    </li>
  </ul>
</div>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .table-legend {
    --table-row-default-bg: #ffeaa5;
    margin-top: 0.75rem;
  }

  .table-legend__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .table-legend__item {
    align-items: center;
    color: var(--theme-colour-text-primary);
    display: flex;
    font-family: var(--theme-font-family-note);
    // font-size: calc(0.85 * var(--theme-font-size-base));
    gap: 0.15rem;
    margin: 0 0 0.35rem;
    @include mixins.text-xs;
  }

  .table-legend__key {
    border-radius: 2px;
    display: inline-block;
    flex: 0 0 1.25rem;
    height: 1rem;
    overflow: hidden;
    position: relative;
  }

  .table-legend__key--fill {
    background: var(--table-row-default-bg);
  }

  .table-legend__key--pattern::after {
    // background-image: repeating-linear-gradient(
    //   -45deg,
    //   color-mix(in srgb, var(--theme-colour-text-primary) 12%, transparent) 0
    //     4px,
    //   transparent 4px 8px
    // );
    content: '';
    inset: 0;
    pointer-events: none;
    position: absolute;
    background-image: var(--icon);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
</style>
